// tslint:disable
export enum AccountExternalIdType {
    /**
     * @description UNKNOWN
     */
    UNKN = 0,
    /**
     * @description UBC Hub Identifier
     */
    UBCHUBID = 1,
    /**
     * @description TrialCard Hub Identifier
     */
    TrialCardHubId = 2,
    /**
     * @description Member Number
     */
    MemberNumber = 3,
    /**
     * @description ADLDS Login
     */
    ADLDS = 4,
    /**
     * @description Medical Member ID
     */
    MedMemberID = 5,
    /**
     * @description Pharmacy Member ID
     */
    PharMemberID = 6,
    /**
     * @description Third Party Id
     */
    THIRDPARTYID = 7,
    /**
     * @description AssistRx Rx ID
     */
    ARXRxId = 8,
    /**
     * @description CarePath ID
     */
    CarePathId = 9,
    /**
     * @description Vermedica Patient Id
     */
    VMIPatientId = 10,
    /**
     * @description Portico Portal Id
     */
    PorticoPortalId = 11,
    /**
     * @description Site Account ID
     */
    SiteAccountId = 12,
    /**
     * @description McKesson Patient Id
     */
    PatientMckId = 13,
    /**
     * @description REMS ID
     */
    RemsId = 14,
    /**
     * @description Mango Activation Id
     */
    MangoActivationId = 15,
    /**
     * @description Partner Patient Id
     */
    PatientPartnerId = 16,
    /**
     * @description Partner Patient Id
     */
    PartnerPatientId = 17,
    /**
     * @description Sunovion ID
     */
    SunovionID = 18,
    /**
     * @description PharmaCord Patient ID
     */
    PharmaCordPatientId = 19,
    /**
     * @description IBond ID
     */
    IBondId = 20,
    /**
     * @description IBond Enrollment ID
     */
    IBondEnrollmentId = 21,
    /**
     * @description Infinitus ID
     */
    InfinitusId = 22,
    /**
     * @description EvinceMed ID
     */
    EvinceMedId = 23,
    /**
     * @description Subject ID
     */
    SubjectId = 24,
    /**
     * @description CMM Case Key
     */
    CMMCaseKey = 25,
}
(AccountExternalIdType as any)['TRIALCARDHUBID'] = 2;
(AccountExternalIdType as any)['MEMBERNUMBER'] = 3;
(AccountExternalIdType as any)['MEDMEMBERID'] = 5;
(AccountExternalIdType as any)['PHARMEMBERID'] = 6;
(AccountExternalIdType as any)['ARXRXID'] = 8;
(AccountExternalIdType as any)['CAREPATHID'] = 9;
(AccountExternalIdType as any)['VMIPATIENTID'] = 10;
(AccountExternalIdType as any)['PORTICOPORTALID'] = 11;
(AccountExternalIdType as any)['SITEACCOUNTID'] = 12;
(AccountExternalIdType as any)['PATIENTMCKID'] = 13;
(AccountExternalIdType as any)['REMSID'] = 14;
(AccountExternalIdType as any)['MANGOACTIVATIONID'] = 15;
(AccountExternalIdType as any)['PATIENTPARTNERID'] = 16;
(AccountExternalIdType as any)['PARTNERPATIENTID'] = 17;
(AccountExternalIdType as any)['SUNOVIONID'] = 18;
(AccountExternalIdType as any)['PHARMACORDPATIENTID'] = 19;
(AccountExternalIdType as any)['IBONDID'] = 20;
(AccountExternalIdType as any)['IBONDENROLLMENTID'] = 21;
(AccountExternalIdType as any)['INFINITUSID'] = 22;
(AccountExternalIdType as any)['EVINCEMEDID'] = 23;
(AccountExternalIdType as any)['SUBJECTID'] = 24;
(AccountExternalIdType as any)['CMMCASEKEY'] = 25;
